import store from "@/api/Store.js";
import _ from 'lodash'

let me = {
    store,
    api: null,
    rootVueInstance: null
}

me.setClientAPI = (c) =>  { me.api = c }
me.setRootVueInstance = (r) => me.rootVueInstance = r.$root;

me.commit = me.store.commit

me.getContext = () => {
    return me.store.state.context;
}

me.setFormData = (f/*, params*/) => {
    /*
    if (!(params||{}).dontUpdateForm) {
        me.api.forceUpdate()
    }
    */

    me.api.store.commit("setFormData", f)
    me.updateWidgets()
}
/**
 * todos los componentes deben tener el nombre del campo que representan (name=xxx)
 * y deben responder al evento setvalue.
 *
 *   <input :name="name" @setvalue="setValue" ...
 *
 * esto hace que se pueda actualizar el widget
 */
me.updateWidgets = () => {
    me.api.applyAll(n => {
        let widgets = document.getElementsByName(n.name);
        window._.each(widgets, w => w.dispatchEvent(new Event('setvalue')))
    });
}

/**
 * Puede usarse de varias formas:
 *  a) Si no se pasa una clave, devuelve todos los valores del formulario.
 *  b) Si se pasa una clave, devuelve ese valor del formulario.
 *  c) si se pasa un id y una clave, se busca el valor de dicha clave y se devuelve valor[id]. Es
 *     decir, si es un objeto devuelve dicho atributo, y si es una lista devuelve
 *     la entrada que tenga dicho id en el valor del formulario.
 * @param {*} key
 * @param {*} id - busca en una coleccion
 * @param {*} attr - si se busca en una coleccion, devuelve este atributo
 * @returns
 */
me.getFormData = (key, id, attr) => {
    let c = me.api.store.state.formData;

    let res = key ? c[key] : c;
    if (id === undefined || id === null) return attr ? (res ||{})[attr] : res

    let res2 = window._.find(res, { id: id} )
    if (res2 && attr) res2 = res2[attr]
    return res2
}

/**
 * Busca un dato del formulario o variable que es una lista, localiza una entrada con el id indicado y lo devuelve.
 * Por ejemplo, api.find('terceros', 43) localiza el tercero con id 43 en
 * la lista de terceros de la variable o dato terceros.
 *
 * @param {*} key El nombre de la variable a resolver para obtener una coleccion. Tambien puede pasarse la coleccion directamente
 * @param {*} id  El identificador de la entrada a buscar. Si es un array, devuelve un array.
 * @param {*} idAttr  El atributo para utilizar en la comparacion. id por defecto.
 * @returns El objeto encontrado.
 */
window.__F = me.find = (key, id, idAttr) => {
    idAttr = idAttr || 'id'
    const res = Array.isArray(key) ? key : me.get(key)
    if (id === undefined || id === null) return res

    if (Array.isArray(id)) {
        return window._.filter(res, i => id.includes(i[idAttr] || i?.id || i))
    }

    if (id[idAttr]) id = id[idAttr]
    id = String(id)



    let res2 = window._.find(res, i => String(i[idAttr]) == id)
    return res2
}

/**
 * Equivalente a __F, pero actualiza el valor encontrado con newVal
 * @param {*} key
 * @param {*} id
 * @param {*} newVal
 */
window.__U = me.__U = (key, newVal) => {
    let col = []
    if (Array.isArray(key)) col = key
    else col = window.api.__(key) || []

    const ndx = _.findIndex(col, i => i?.id == newVal?.id)
    if (ndx < 0) col.push(newVal)
    else col[ndx] = newVal

    if (window.api.getVariables()[key]) window.api.setVariable(key, col)
    else window.api.set(key, col)


    return col
}

/**
 * Devuelve una coleccion sin el elemento indicado por id/idAttr
 */
window.__D = me.__D = (key, obj, idAttr) => {

    idAttr = idAttr || 'id'
    const id = obj?.id || obj

    const res = me.get(key)
    if (id === undefined || id === null) return res

    let col = window._.filter(res, i => {
        if (_.isObject(i)) return String(i[idAttr]) != String(id)
        return String(i) != String(id)
    })

    if (window.api.getVariables()[key]) window.api.setVariable(key, col)
    else window.api.set(key, col)

    return col
}

/**
 * Equivalente a _F, pero hace un flatten que lo que se le pase por parametro.
 * Se usa para trabajar con arboles.
 */
window.__FL = me.find = (key, id, idAttr) => {
    idAttr = idAttr || 'id'
    let res = me.get(key)
    res = window.api.flatten(res)

    if (id === undefined || id === null) return null

    let res2 = window._.find(res, i => String(i[idAttr]) == String(id))
    // if (!res2) res2 = window._.find(res, { [idAttr]: +id} )

    return res2
}

window.__L = me.get_length = (key) => {
    const res = me.get(key)
    return res?.length
}

me.updateCollectionEntry = (key, id, obj) => {
    let row = me.getFormData(key, id)
    window._.each(obj, (value,attr) => {
        window.Vue.set(row, attr, value)
    })
}


// return this.get(key) || (this.getResponse() || {})[key] || (((api.getResponse() || {}).formData || {}).submission || {})[key] || this.getConfiguration()[key]
me.__ = me.___ = me.get = (dottedk, defaultValue) => {
    if (!dottedk) return null
    let key = dottedk
    let attrDots = null
    if (dottedk.includes('.')) {
        let pos = dottedk.indexOf('.')
        key = dottedk.substring(0, pos);
        attrDots = dottedk.substring(pos+1);
    }

    let r = me.getResponse() || {}
    let rfd = r.formData || {}
    let rfds = rfd.submission || {}

    let response =
        me.store.state.formData[key]
        || me.api.store.state.context.variables[key]
        || r[key]
        || rfd[key]
        || rfds[key]
        || (me.getEntorno() || {})[key]
        || (me.getConfiguration('entornos') || {})[key]
        || me.getConfiguration(key)
        || me.getContext()[key]
    if (!attrDots) return response || defaultValue

    const v = window._.get(response || window.api.getComponent(key), attrDots)
    if (v != undefined) return v

    return defaultValue
}


me._set = (key, value, store) => {
    if (!key) return
    if (!store) throw 'api._set llamado sin especificar el store!'
    const firstIndex = key.indexOf('.')
    if ( firstIndex == -1)  {
        me.api.store.commit(store, { key, value })
        setTimeout( () => {
            me.api.eventPublish('on_change_' + key, value)
        }, 100)
        return
    }

    const lastIndex = key.indexOf('.')
    const objKey = key.substring(0, firstIndex)
    // const obj = me.store.state.formData[objKey] || {}
    // eval('debugger')
    let obj = window.api.get(objKey)
    if (!obj) {
        me.set(objKey, {})
        obj = window.api.get(objKey)
    }

    const attr = key.substring(lastIndex + 1)
    _.set(obj, attr, value)
    me.api.store.commit(store, { objKey, obj })

    me.api.eventPublish('on_change_' + key, value)
}

me.set = (key, value) => me._set(key, value, "set")
me.setVariable = (key, value) => me._set(key, value, "setVariable")

me.push_uniq = (key, obj, id_attr) => {
    id_attr = id_attr || 'id'
    me.set(key, me.get(key) || [])
    const array = me.get(key)
    const index = array.findIndex(item => item[id_attr] === obj[id_attr]);
    if (index !== -1) {
      array[index] = obj;
    } else {
      array.push(obj);
    }
}

me.push = (key, obj) => {
    const arr = me.get(key) || []
    arr.push(obj)
    me.set(key, arr)
}

me.filter = (key, filterFn) => {
    const k = _.filter(me.get(key), filterFn)
    me.set(key, k)
};

me.filterVariable = (key, filterFn) => {
    const k = _.filter(me.getVariable(key), filterFn)
    me.setVariable(key, k)
};

me.pushVariable = (key, value) => {
    let k = me.getVariable(key)
    if (k == null) {
        me.setVariable(key, [])
        k = me.getVariable(key)
    }
    k.push(value)
}

me.unset = (key) => {
    // window.console.log('unset>', key)
    me.api.store.commit("set", { key, value: null })
}

me.getVariables = () => {
    return me.api.store.state.context.variables;
}

me.getVariable = (dottedExpression, id) => {
    let r = window._.get( me.api.store.state.context.variables, dottedExpression);
    if (id != null && id !== undefined) r = window._.find(r, e => +e.id === +id )
    // window.console.log('me.getVariable', dottedExpression, id, r)
    return r
}

me.getConfiguration = (key) => {
    let c = me.store.state.context.configuration;

    return key ? c[key] : c;
}

me.getObservability = (key) => {
    let c = me.store.state.context.observability;

    return key ? c[key] : c;
}

me.setObservability = (f) => {
    window.console.log('me.setObservability>', f)
    me.store.commit("setObservability", f)
}

me.setConfiguration = (f) => {
    window.console.log('me.setConfiguration>', f)
    if (f.entornos && !f.entornos.entorno_activo) {
        f.entornos.entorno_activo = _.findKey( f.entornos || {}, e =>  (e.hosts || []).includes(window.location.hostname))
        // window.console.log('Fijando entorno activo a ', f.entornos.entorno_activo)
    }
    // me.api.forceUpdate()
    me.store.commit("setConfiguration", f)
    // this.HTTP.setAuth(this.getAuth()) // todo 2022-07.
}

me.getComponent = (c) => {
    if (c?.nodeUUID) {
        const byUUID = me.api.getVueElementForNode(c)
        if (byUUID) return byUUID
    }

    let v = me.rootVueInstance.$root.$refs[c?.name || c]
    if (v) return v

    if (c?.nodeUUID) {
        return me.api.getVueElementForNode(c)
    }

    return null
}

me.getEntorno = (attrDots) => {
    var entornos = me.getConfiguration('entornos') || {};
    let env = entornos[entornos.entorno_activo] || {};
    return attrDots? window._.get(env, attrDots) : env
}

me.getResponse = (attr) => {
    let r = me.store.state.context.response
    if(!r) return null

    return attr ? r[attr] : r
}

me.setResponse = (r) => me.commit("setResponse", r)
me.getAuth = () => me.getEntorno().auth;

me.addValidationError = (f) => me.store.commit("addValidationError", f)

export default me
